import { transactionService, searchService } from '@/utils/request'

// 商品管理及作品信息相关接口

// 获取列表数据
export function getGoodsList (params) {
  return transactionService({
    url: 'works/list',
    method: 'get',
    params: params
  })
}

// 申请上架
export function worksAuditReCommit (data) {
  return transactionService({
    url: 'worksAudit/reCommit',
    method: 'post',
    data: data
  })
}

// 取消上架
export function worksAuditCancel (data) {
  return transactionService({
    url: 'worksAudit/cancel',
    method: 'post',
    data: data
  })
}

// 下架
export function worksSoldOut (data) {
  return transactionService({
    url: `works/soldOut?worksId=${data.worksId}`,
    method: 'post',
    data: data
  })
}

// 获取商品-作品基础信息-交易系统
export function getWorksInfoByWorksId (worksId) {
  return transactionService({
    url: `works/detail?worksId=${worksId}`,
    method: 'get'
  })
}

// 获取商品-作品基础信息-资源管理
// is_res_c: 获取C端作品数据
export function getWorksInfoByOriginId (data) {
  return searchService({
    url: 'api/resadmin/common/detail',
    method: 'post',
    data: data
  })
}

// 获取审核历史记录
export function getWorksAuditHistory (id) {
  return transactionService({
    url: `worksAudit/history?worksId=${id}`
  })
}
